const state = {
    shipmentInformationFields: [
        {
            key: "package_word_code",
            label: "包裝作業單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "shipment_code",
            label: "包裝工令單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "package_code",
            label: "包裝編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "package_method",
            label: "包裝方式",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "shipment_item",
            label: "發料批號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "shipment_data",
            label: "發料批號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "mark",
            label: "嘜頭",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        // {
        //     key: "bar_code",
        //     label: "條碼",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // }
    ],
    shipmentInformationItem: [
        {
            // package_word_code: "AC021730001",
            // shipment_code: "AC021730001001",
            // package_code: "OFXXAD10D035G3XX",
            // package_method: "小盒",
            // shipment_item: [{ name: "裸成品", data: ["A0022(LOT145、M10) 14141PCS(413,624KG)", "A0023(LOT143、M10) 6859PCS(200,625KG)", "A0013(LOT52、M10) 2500PCS(73,125KG)"] }, { name: "成品", data: ["A0010(LOT143、M10) 6500PCS(190,125KG)", "A0025(LOT145、M10) 1000PCS(29,250KG)"] }],
            // mark: "A00022",
            // bar_code: "POS.13",
        }
    ],
}
const getters = {
    get_shipmentInformationFields: state => {
        return state.shipmentInformationFields
    },
    get_shipmentInformationItem: state => {
        return state.shipmentInformationItem
    },
}
const actions = {
    set_shipmentInformationFields(context, array) {
        context.commit('SET_SHIPMENTINFORMATIONFIELDS', array);
    },
    set_shipmentInformationItem(context, array) {
        context.commit('SET_SHIPMENTINFORMATIONITEM', array);
    },
    clear_shipmentInformationItem(context) {
        context.commit('CLEAR_SHIPMENTINFORMATIONITEM');
    },
}
const mutations = {
    SET_SHIPMENTINFORMATIONFIELDS(state, array) {
        state.shipmentInformationFields = array;
    },
    SET_SHIPMENTINFORMATIONITEM(state, array) {
        state.shipmentInformationItem = array;
    },
    CLEAR_SHIPMENTINFORMATIONITEM(state) {
        state.shipmentInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shipmentInformation.js